import { render, staticRenderFns } from "./AddObjectSite.vue?vue&type=template&id=5b6d3e78&"
import script from "./AddObjectSite.vue?vue&type=script&lang=js&"
export * from "./AddObjectSite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports